import { useSelector } from "react-redux";
import type { RootState } from "@/store";

export const useIsEmployeeAccountLinked = (): boolean => Boolean(
  useSelector((state: RootState) => state.session.user?.representative?.linked_employee_id),
);
